<template>
  <v-dialog v-model="newUserDialog" max-width="500px" persistent scrollable>
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title><h4>New User</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)" color="black" size="30"
          >close</v-icon
        >
      </v-toolbar>
      <v-card-text style="height: auto" class="px-4 pt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div
            style="
              display: flex;
              justify-content: center;
              cursor: pointer;
              position: relative;
            "
            @click="$refs.AvatarInput.click()"
          >
            <div
              style="
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                position: absolute;
                z-index: 1;
                width: 120px;
                height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 5px;
                background-color: rgba(0, 0, 0, 0.5);
              "
              v-if="imageSrc"
            >
              <v-icon color="white">edit</v-icon>
            </div>
            <v-img
              v-if="imageSrc"
              color="info"
              class="white--text"
              :src="imageSrc"
              max-width="120px"
              height="120px"
              style="position: relative; z-index: 0"
            />
            <div
              style="
                width: 120px;
                height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(0, 0, 0, 0.5);
                border-radius: 5px;
              "
              v-else
            >
              <v-icon color="white">add</v-icon>
            </div>
          </div>
          <input
            style="display: none"
            type="file"
            @change="onAvatarSelected"
            ref="AvatarInput"
            accept="image/*"
          />
          <v-layout row>
            <v-flex xs2 class="mr-2">
              <v-select
                :items="country_tel"
                v-model="form.user_partner_country_tel"
                label="Select"
              ></v-select>
            </v-flex>
            <v-flex xs9 class="ml-2">
              <v-text-field
                v-model="form.user_partner_tel"
                label="Tel."
                :rules="[telValid.leng, telValid.required]"
                :loading="isCheckingTel"
                @input="checkTel()"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs1
              class="ml-2"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                :style="{
                  backgroundColor: validTel == true ? '#4caf50' : 'red',
                }"
                style="
                  background-color: red;
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <v-icon color="white" size="20">{{
                  validTel == true ? "check" : "close"
                }}</v-icon>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6 class="mr-2">
              <v-text-field
                v-model="form.user_partner_first_name"
                label="First name"
                :rules="[nameValid.max, nameValid.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="ml-2">
              <v-text-field
                v-model="form.user_partner_last_name"
                label="Last name"
                :rules="[nameValid.max, nameValid.required]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <!-- <v-text-field
              v-model="form.user_partner_email"
              label="Email"
              :rules="[
                emailValid.email,
                emailValid.required,
                emailValid.already,
                nameValid.max,
              ]"
            ></v-text-field> -->
            <v-autocomplete
              v-model="form.user_partner_province_id"
              :items="province_list"
              outlined
              :loading="loadingProvince"
              item-text="province_name_th"
              item-value="province_id"
              dense
              label="Select province"
              @change="getDistrictList()"
              :rules="[(v) => !!v || 'Required']"
            ></v-autocomplete>
            <v-autocomplete
              v-if="form.user_partner_province_id != null"
              v-model="form.user_partner_district_id"
              :items="districtList"
              outlined
              :loading="isLoadingDistrict"
              item-text="district_name_th"
              item-value="district_id"
              dense
              chips
              small-chips
              label="Select district"
              multiple
              :rules="[(v) => v.length > 0 || 'Required']"
            ></v-autocomplete>
            <div class="line-newpass"></div>
            <v-text-field
              v-model="form.user_partner_password"
              :append-icon="show1 ? 'visibility_off' : 'visibility'"
              :type="show1 ? 'text' : 'password'"
              label="Password"
              autocomplete="new-password"
              hint="At least 6 characters"
              class="input-group--focused"
              @click:append="show1 = !show1"
              :rules="[
                passwordValid.min,
                passwordValid.max,
                passwordValid.match,
              ]"
            ></v-text-field>
            <v-text-field
              v-model="form.user_partner_confirm_password"
              :append-icon="show2 ? 'visibility_off' : 'visibility'"
              :type="show2 ? 'text' : 'password'"
              autocomplete="new-password"
              label="Confirm Password"
              hint="At least 6 characters"
              class="input-group--focused"
              @click:append="show2 = !show2"
              :rules="[
                passwordValid.min,
                passwordValid.max,
                passwordValid.match,
              ]"
            ></v-text-field>
          </v-flex>
        </v-form>
      </v-card-text>
      <v-card-actions style="padding-bottom: 30px" class="pr-4">
        <v-spacer></v-spacer>
        <v-btn
          :loading="isAdding"
          dark
          color="black"
          style="
            width: 120px;
            background: #000000 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 7px;
            font-weight: bold;
            letter-spacing: 0.1rem;
          "
          @click="addUser()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import _ from "lodash";

let _this = this;
export default {
  props: ["newUserDialog"],
  data() {
    return {
      isCheckingTel: false,
      user_province_type: 1,
      loadingProvince: false,
      user_province: [],
      user_country_tel: "+66",
      country_tel: ["+66"],
      passwordMatch: true,
      RoleItems: [
        {
          name: "SuperAdmin",
          value: 1,
        },
        {
          name: "Admin",
          value: 2,
        },
        {
          name: "Viewer(Manager)",
          value: 3,
        },
        {
          name: "Callcenter",
          value: 4,
        },
        {
          name: "Customer",
          value: 6,
        },
        {
          name: "RiderManager",
          value: 8,
        },
        {
          name: "Accounting",
          value: 9,
        },
        {
          name: "Marketing",
          value: 10,
        },
        {
          name: "AdminLaborStore",
          value: 11,
        },
      ],
      password1: "",
      password2: "",
      show1: false,
      show2: false,
      tel: "",
      verify: "",
      email: "",
      fname: "",
      lname: "",
      role: 1,
      valid: true,
      telValid: {
        required: (value) => !!value || "Required.",
        leng: (v) => v.length == 9 || "9 characters only",
        already: (a) => !this.telAlready(a) || "Already in use",
      },
      nameValid: {
        required: (value) => !!value || "Required.",
        max: (v) => v.length <= 55 || "Min 55 characters",
      },
      // emailValid: {
      //   already: (a) => !this.emailAlready(a) || "Already in use",
      //   required: (value) => !!value || "Required.",
      //   email: (value) => {
      //     const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //     return pattern.test(value) || "Invalid e-mail.";
      //   },
      // },
      roleValid: {
        required: (value) => !!value || "Required.",
      },
      passwordValid: {
        min: (v) => v.length >= 6 || "At least 6 characters",
        max: (v) => v.length <= 24 || "No more than 24 characters",
        match: (val) => this.isPasswordMatch || "Password not match",
      },
      form: {
        user_partner_first_name: "",
        user_partner_last_name: "",
        user_partner_country_tel: "+66",
        user_partner_tel: "",
        user_partner_verify: true,
        user_partner_email: "",
        user_partner_password: "",
        user_partner_province_id: null,
        user_partner_district_id: [],
        user_partner_image: "",
        user_partner_confirm_password: "",
      },
      districtList: [],
      isLoadingDistrict: false,
      validTel: false,
      debouceTel: false,
      imageSrc: null,
      isAdding: false,
    };
  },
  watch: {
    async newUserDialog() {
      if (this.newUserDialog == true) {
        this.clear();
        this.loadingProvince = true;
        await this.$store.dispatch("fetchProvinceBack/getData");
        this.loadingProvince = false;
      }
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.fetchUserBack.userData,
    }),
    ...mapGetters({
      isEditStaff: "isEditStaff",
      province_list: "fetchProvinceBack/provinceSplited",
    }),
    isPasswordMatch() {
      if (
        this.form.user_partner_confirm_password ==
        this.form.user_partner_password
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
      checkManagerTel: "fetchUserBack/checkManagerTel",
    }),
    onAvatarSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imageSrc = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async checkTel() {
      this.validTel = false;
      clearTimeout(this.debouceTel);
      if (this.form.user_partner_tel.length != 9)
        return (this.isCheckingTel = false);

      this.isCheckingTel = true;
      this.validTel = false;
      let _this = this;
      this.debouceTel = setTimeout(async function () {
        let config = {
          tel: _this.form.user_partner_tel,
        };
        _this.validTel = await _this.checkManagerTel(config);
        _this.isCheckingTel = false;
      }, 500);
    },
    telAlready(a) {
      let check = 0;
      for (let key in this.userData) {
        if (a == this.userData[key].user_tel) {
          check = 1;
        }
      }
      if (check == 0) {
        return false;
      } else {
        return true;
      }
    },
    emailAlready(a) {
      let check = 0;
      for (let key in this.userData) {
        if (a == this.userData[key].user_email) {
          check = 1;
        }
      }
      if (check == 0) {
        return false;
      } else {
        return true;
      }
    },
    async addUser() {
      if (this.$refs.form.validate() && this.validTel) {
        let payload = JSON.parse(JSON.stringify(this.form));
        if (this.imageSrc == null) {
          delete payload.user_partner_image;
        } else {
          payload.user_partner_image = this.imageSrc;
        }
        this.isAdding = true;
        let _this = this;
        this.$emit("onSaved", {
          form: payload,
          done() {
            _this.isAdding = false;
          },
        });
      }
    },
    async getDistrictList() {
      this.form.user_partner_district_id = [];
      this.districtList = [];
      this.isLoadingDistrict = true;
      this.districtList = await this.getDistrictCore(
        this.form.user_partner_province_id
      );
      this.isLoadingDistrict = false;
    },
    clear() {
      this.form = {
        user_partner_first_name: "",
        user_partner_last_name: "",
        user_partner_country_tel: "+66",
        user_partner_tel: "",
        user_partner_email: "",
        user_partner_verify: true,
        user_partner_password: "",
        user_partner_province_id: null,
        user_partner_district_id: [],
        user_partner_image: "",
        user_partner_confirm_password: "",
      };
      this.validTel = false;
      this.$refs.form.resetValidation();
      this.imageSrc = null;
    },
  },
};
</script>

<style>
.line-newpass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-newpass:after {
  content: "Set Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
